import type { TournamentSort } from '@brush/api-client';
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import type { TournamentSortState } from '../../tournamentSort';

/**
 * A sortable column heading. `aria-sort` carries the state for screen readers, and the arrow
 * shows on every sortable column rather than only the active one — otherwise there is nothing
 * to tell an operator which headings can be clicked at all.
 */
export function SortHeader({
  column,
  label,
  sort,
  onSort,
}: {
  column: TournamentSort;
  label: string;
  sort: TournamentSortState;
  onSort: (column: TournamentSort) => void;
}) {
  const active = sort.column === column;
  const Icon = !active ? ChevronsUpDown : sort.direction === 'asc' ? ChevronUp : ChevronDown;

  return (
    <th
      scope="col"
      aria-sort={active ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      className="px-6 py-3 font-medium"
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        className={`group inline-flex items-center gap-1 transition hover:text-ink-950 ${
          active ? 'text-ink-950' : ''
        }`}
      >
        {label}
        <Icon
          className={`size-3 ${active ? 'text-felt-700' : 'text-ink-800/30 group-hover:text-ink-800/60'}`}
        />
      </button>
    </th>
  );
}
